module.exports = __webpack_public_path__ + "img/David_Ben_Kay.7902eb74.png";